<template>
  <div class="row">
    <div class="col-12">
      <template>
        <component
          :is="component"
          :documentInfo.sync="documentInfo"
        />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'fire-detection-alarm-system-doc',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
        }
      },
    },
  },
  data() {
    return {
      editable: true,
      documentInfo: {
        documentClassCd: 'FIDA', // FIRE_DETECTION_ATTACH
        title: '화재탐지 및 경보설비 설치계획 문서',
      },
      component: null,
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.component = () => import('@/pages/psi/documentMaster.vue');
      this.documentInfo.title = this.$comm.getLangLabel('LBL0010517'); // 화재탐지 및 경보설비 설치계획 문서
    },
    reset() {
      Object.assign(this.$data.documentInfo, this.$options.data().documentInfo);
    },
  }
};
</script>